import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionDireccionTrabajoTitulacionArticuloDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionDireccionTrabajoTitulacionArticuloService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionDireccionTrabajoTitulacionArticuloService(): Observable<BodyListResponse<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>>(API_URL + '/api/v1/estadoRevisionDireccionTrabajoTitulacionArticulo/todos');
  }

  guardarEstadoRevisionDireccionTrabajoTitulacionArticuloService(estadoRevisionDireccionTrabajoTitulacionArticuloDTO: EstadoRevisionDireccionTrabajoTitulacionArticuloDTO): Observable<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO> {
    return this.http.post<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>(API_URL + '/api/v1/estadoRevisionDireccionTrabajoTitulacionArticulo', estadoRevisionDireccionTrabajoTitulacionArticuloDTO);
  }

  getEstadoRevisionDireccionTrabajoTitulacionArticuloPorCodigoEstadoRevisionDireccionTrabajoTitulacionArticuloService(codigoEstadoRevisionDireccionTrabajoTitulacionArticulo: string): Observable<BodyResponse<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>>(API_URL + '/api/v1/estadoRevisionDireccionTrabajoTitulacionArticulo/' + codigoEstadoRevisionDireccionTrabajoTitulacionArticulo);
  }

  getEstadoRevisionDireccionTrabajoTitulacionArticuloPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionDireccionTrabajoTitulacionArticuloDTO>>(API_URL + '/api/v1/estadoRevisionDireccionTrabajoTitulacionArticulo/persona/' + codigoPersona);
  }

}
